import { useState } from "react";

import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import PersonIcon from "@mui/icons-material/Person";

const ProfileMenu = ({ adminDetails, onViewProfile, onLogout }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleViewProfile = () => {
    handleClose();
    onViewProfile();
  };
  const handleLogout = () => {
    handleClose();
    onLogout();
  };

  const initials = adminDetails
    ? `${adminDetails.FirstName?.[0] || ""}${adminDetails.LastName?.[0] || ""}`.toUpperCase()
    : "A";

  return (
    <Box>
      <Tooltip title="Account settings">
        <IconButton onClick={handleOpen} sx={{ p: 0 }}>
          <Avatar className="header-avatar">{initials}</Avatar>
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{ mt: "50px" }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ elevation: 3, className: "profile-menu__paper" }}
      >
        <MenuItem onClick={handleViewProfile} className="profile-menu__item">
          <PersonIcon className="profile-menu__item--icon" />
          View Profile
        </MenuItem>

        <Divider sx={{ my: 0.5 }} />

        <MenuItem
          onClick={handleLogout}
          className="profile-menu__item profile-menu__item--logout"
        >
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ProfileMenu;
